module.exports = __webpack_public_path__ + "static/media/start.ca41540e.png";